import React from 'react';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const Graph = ({ data }) => {
    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5, right: 30, left: 20, bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" />
                <YAxis yAxisId="left" />
                <YAxis yAxisId="right" orientation="right"/>
                <Tooltip/>
                <Legend/>
                
                <Line yAxisId="left" type="linear" dataKey="partnerRequests" stroke="#ff0000" dot={{ stroke: '#ff0000', strokeWidth: 3 }} activeDot={{ stroke: '#ff0000', strokeWidth: 3 }} strokeWidth={3}/>
                <Line yAxisId="left" type="linear" dataKey="wins" stroke="#008000" dot={{ stroke: '#008000', strokeWidth: 3 }} activeDot={{ stroke: '#008000', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="left" type="linear" dataKey="impressions" stroke="#F19A3E" dot={{ stroke: '#F19A3E', strokeWidth: 3 }} activeDot={{ stroke: '#F19A3E', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="left" type="linear" dataKey="clicks" stroke="#E34A6F" dot={{ stroke: '#E34A6F', strokeWidth: 3 }} activeDot={{ stroke: '#E34A6F', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="left" type="linear" dataKey="revenue" stroke="#EFCA08" dot={{ stroke: '#EFCA08', strokeWidth: 3 }} activeDot={{ stroke: '#EFCA08', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="right" type="linear" dataKey="ctr" stroke="#F08700" dot={{ stroke: '#F08700', strokeWidth: 3 }} activeDot={{ stroke: '#F08700', strokeWidth: 3 }} strokeWidth={3} />
                <Line yAxisId="right" type="linear" dataKey="winsPercent" stroke="#00A6A6" dot={{ stroke: '#00A6A6', strokeWidth: 3 }} activeDot={{ stroke: '#00A6A6', strokeWidth: 3 }} strokeWidth={3} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default Graph;


// WEBPACK FOOTER //
// ./src/scenes/BidderV2/components/Graph/index.js